export const participantes = {
  secao: 'Participantes',
  elegiveis: 'Na campanha: {{n}}',
  excluidos: 'Excluídos: {{n}}',
  acionadaPor: 'Acionada por',
  contagens: {
    incluidos: 'Incluídos nesta sincronização',
    alterados: 'Alterados',
    reativados: 'Reativados',
    excluidos: 'Excluídos nesta sincronização',
    ignorados: 'Ignorados',
  },
  resultado: { sucesso: 'Sucesso', falha: 'Falha' },
  confirmar:
    'Isso consulta o Axiis, inclui os profissionais ativos que ainda não estão na campanha, atualiza os dados de quem já está e marca como excluídos os desligados. Nenhuma resposta é apagada. Continuar?',
  confirmarAtivacao: 'O link passa a aceitar respostas.',
  sincronizado: 'Sincronização concluída: {{incluidos}} incluídos, {{excluidos}} excluídos.',
  falhou: 'A sincronização falhou. Veja o motivo no resumo.',
  status: {
    sincronizada_one: 'Sincronizado em {{quando}} · {{count}} na campanha',
    sincronizada_other: 'Sincronizado em {{quando}} · {{count}} na campanha',
    sincronizadaEm: 'Sincronizado em {{quando}}',
    detalhes: 'Detalhes',
  },
  aba: 'Participantes',
  painel: {
    totais: {
      elegiveis: 'Na campanha',
      responderam: 'Responderam',
      naoResponderam: 'Não responderam',
      queremBrinde: 'Querem o brinde',
      exterior: 'Recebem no exterior',
    },
    filtros: {
      busca: 'Nome, e-mail ou matrícula',
      buscaChip: 'Busca',
      respondeu: 'Resposta',
      brinde: 'Brinde',
      axiis: 'Gravação no Axiis',
      convite: 'Convite',
      todos: 'Todos',
      sim: 'Sim',
      nao: 'Não',
      falha: 'Com falha',
      pendente: 'Pendente',
      falhaOuPendente: 'Com falha ou pendente',
      situacao: 'Situação',
      rotulo: '{{filtro}}: {{valor}}',
    },
    situacao: { elegivel: 'Na campanha', excluido: 'Excluídos' },
    colunas: {
      matricula: 'Matrícula',
      nome: 'Nome',
      resposta: 'Resposta',
      brinde: 'Brinde',
      camiseta: 'Camiseta',
      endereco: 'Endereço',
      atualizadaEm: 'Atualizada em',
      acoes: 'Ações',
      convite: 'Convite',
    },
    respondeu: 'Respondeu',
    naoRespondeu: 'Não respondeu',
    entrega: {
      cadastro: 'Cadastro',
      outro: 'Outro',
      exterior: 'Exterior',
      sem: 'Sem endereço de entrega',
    },
    oficial: 'Oficial: {{situacao}}',
    gravacao: { sucesso: 'Gravada', pendente: 'Pendente', falha: 'Falha', cancelada: 'Cancelada' },
    vazio: 'Nenhum participante. Sincronize a campanha.',
    semResultado: 'Nenhum participante com esses filtros.',
  },
  linha: { abrir: 'Abrir {{nome}}' },
  detalhe: {
    titulo: 'Detalhes do participante',
    semResposta: 'Esta pessoa ainda não respondeu.',
    semAlteracaoOficial: 'Sem alteração',
    matricula: 'Matrícula {{matricula}}',
    nome: 'Nome',
    nomeSocial: 'Nome social',
    nomePrefer: 'Nome preferido',
    incluidoEm: 'Incluído em',
    primeiroAcesso: 'Primeiro acesso',
    camiseta: 'Camiseta',
    versao: 'Versão',
    primeiraResposta: 'Primeira resposta',
    ultimaResposta: 'Última resposta',
    tentativas: '{{n}} tentativas',
    itemCamiseta: 'Camiseta',
    itemEndereco: 'Endereço oficial',
    retentar: 'Tentar gravar de novo',
    retentado_zero: '{{count}} gravados, {{falha}} com falha.',
    retentado_one: '{{count}} gravado, {{falha}} com falha.',
    retentado_other: '{{count}} gravados, {{falha}} com falha.',
    retentadoNada: 'Nada a gravar.',
    elegivel: 'Na campanha',
    excluido: 'Excluído',
    erro: 'Erro ao carregar o participante.',
    erroLista: 'Erro ao carregar os participantes.',
    secoes: {
      identificacao: 'Identificação',
      apresentado: 'Apresentado ao profissional',
      respostas: 'Respostas',
      entrega: 'Endereço de entrega',
      oficial: 'Endereço oficial',
      confirmacoes: 'Confirmações',
      axiis: 'Gravação no Axiis',
      convite: 'Convite',
    },
    fotografiaEm: 'Fotografia de',
    enderecoApresentado: 'Endereço',
    confirmacoesLinha: 'Endereço correto: {{correto}} · Alguém para receber: {{recebedor}}',
    tentativa: '{{n}} tentativa',
  },
  abas: { naCampanha: 'Na campanha', excluidos: 'Excluídos' },
  lote: {
    enviarEmail: 'Enviar e-mail',
    barra: 'Ações em lote',
    selecionados_one: '{{count}} selecionado',
    selecionados_other: '{{count}} selecionados',
    selecionarPagina_one: 'Selecionada {{count}} desta página.',
    selecionarPagina_other: 'Selecionadas {{count}} desta página.',
    selecionarPaginaRotulo: 'Selecionar as linhas desta página',
    selecionarLinha: 'Selecionar {{nome}}',
    selecionarTodosFiltro: 'Selecionar os {{total}} que casam com os filtros',
    selecionarTodos: 'Selecionar todos ({{total}})',
    todosDoFiltroAtivo: '(todos os que casam com os filtros)',
    foraDaLista_one: '{{count}} não aparece nesta lista',
    foraDaLista_other: '{{count}} não aparecem nesta lista',
    verSelecionados: 'Ver selecionados',
    selecionadosTitulo: 'Pessoas selecionadas',
    tirar: 'Tirar {{nome}} da seleção',
    tirarBotao: 'Tirar',
    eMais_one: 'e mais {{count}} pessoa',
    eMais_other: 'e mais {{count}} pessoas',
    limpar: 'Limpar seleção',
    excluir: 'Excluir da campanha',
    devolver: 'Devolver à campanha',
    excluirLinha: 'Excluir {{nome}}',
    devolverLinha: 'Devolver {{nome}}',
    excluirTitulo_one: 'Excluir {{count}} pessoa da campanha?',
    excluirTitulo_other: 'Excluir {{count}} da campanha?',
    devolverTitulo_one: 'Devolver {{count}} pessoa à campanha?',
    devolverTitulo_other: 'Devolver {{count}} à campanha?',
    excluirCorpo_one:
      'Esta pessoa sai da lista, não recebe convites e não entra na exportação. A resposta já enviada é mantida. A sincronização não a traz de volta; para voltar, use "Devolver à campanha".',
    excluirCorpo_other:
      'Estas pessoas saem da lista, não recebem convites e não entram na exportação. As respostas já enviadas são mantidas. A sincronização não as traz de volta; para voltar, use "Devolver à campanha".',
    devolverCorpo_one:
      'Esta pessoa volta à lista da campanha. Se estiver inativa no cadastro, não volta.',
    devolverCorpo_other:
      'Estas pessoas voltam à lista da campanha. Quem está inativo no cadastro não volta.',
    comResposta_one: '{{count}} já respondeu; a resposta é mantida.',
    comResposta_other: '{{count}} já responderam; as respostas são mantidas.',
    resultado: '{{processados}}, {{ignorados}}.',
    soProcessados: '{{processados}}.',
    processados_zero: '{{count}} processados',
    processados_one: '{{count}} processado',
    processados_other: '{{count}} processados',
    ignoradosLote_one: '{{count}} ignorado',
    ignoradosLote_other: '{{count}} ignorados',
    verMotivos: 'Ver motivos',
    motivosTitulo: 'Pessoas ignoradas',
    desatualizada: 'A lista mudou desde que você selecionou. Revise e tente de novo.',
  },
  codigos: {
    INATIVO_NO_AXIIS: 'Inativo no cadastro',
    JA_PARTICIPANTE: 'Já é participante',
    NAO_ENCONTRADO_NO_AXIIS: 'Não encontrado no cadastro',
    JA_EXCLUIDO: 'Já estava excluído',
    NAO_EXCLUIDO: 'Já estava na campanha',
    PARTICIPANTE_NAO_ENCONTRADO: 'Participante não encontrado',
  },
  incluir: {
    botao: 'Adicionar participante',
    titulo: 'Adicionar participantes à campanha',
    busca: 'Buscar por nome ou matrícula',
    somenteAtivos: 'Aparecem só pessoas ativas no cadastro que ainda não estão na campanha.',
    semResultado: 'Ninguém encontrado para esta busca.',
    tentarDeNovo: 'Tentar de novo',
    adicionar: 'Adicionar {{count}}',
  },
  idiomas: { PT: 'Português', EN: 'Inglês', ES: 'Espanhol' },
  colunas: {
    idioma: 'Idioma',
    titulo: 'Colunas',
    visiveis: 'Colunas visíveis',
    redefinir: 'Redefinir',
    aplicar: 'Aplicar',
    nenhuma: 'Escolha ao menos uma coluna.',
    email: 'E-mail',
    acessos: 'Acessos',
    ultimoAcesso: 'Último acesso',
    origem: 'Origem',
    por: 'Excluído por',
  },
  origem: { sincronizacao: 'Sincronização', manual: 'Manual', axiis: 'Cadastro (Axiis)' },
  acessos: { nunca: 'Nunca', janela: 'Contamos uma nova visita a cada 30 minutos.' },
  filtros: {
    avancados: 'Filtros',
    limparTudo: 'Limpar tudo',
    fechar: 'Fechar',
    acessou: 'Acessou',
    temEmail: 'Tem e-mail',
    respondidaEm: 'Respondida em',
    aplicados: 'Filtros aplicados',
    remover: 'Remover filtro {{filtro}}',
  },
  porPagina: 'Itens por página',
  vazio: {
    excluidos: 'Ninguém foi excluído desta campanha.',
    titulo: 'Ninguém na campanha ainda',
    descricao: 'Traga os profissionais ativos do Axiis. Depois você exclui quem não recebe.',
  },
  inicioEFim: 'Início e fim',
} as const;
